import { createEvent, restore, sample } from 'effector'
import { ExchangerTransfer, ExchangerTransferStatus } from './types'
import { fx } from '../../../../libs'
import { $params } from '../../../../features/router'
import qs from 'qs'

export const exchangerTransferMounted = createEvent()

export const setExchangerTransfer = createEvent<ExchangerTransfer>()

export const submitStatus = createEvent<ExchangerTransferStatus>()

export const $exchangerTransfer = restore(setExchangerTransfer, {
  id: '',
  humanCreatedAt: '',
  humanUpdatedAt: '',
  type: '',
  status: '',
  rejectReason: '',
  rollbackReason: '',
  manager: {
    managerId: 0,
    fullName: '',
  },
  client: {
    clientId: 0,
    fullName: '',
    email: '',
    isTest: false,
  },
  exchanger: {
    id: 0,
    owner: {
      clientId: 0,
      fullName: '',
    },
    name: '',
    balance: 0,
  },
  account: {
    id: 0,
    balance: 0,
    currency: '',
    mtLogin: '',
  },
  sourceAmount: '',
  sourceCurrency: '',
  destinationAmount: '',
  destinationCurrency: '',
  note: '',
})

export const getExchangerTransfer = fx<void, ExchangerTransfer>({
  method: 'GET',
  url: '/exchanger-transfer/',
})

sample({
  clock: exchangerTransferMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.exchangerTransferID
    }

    return {
      url: `/exchanger_transfer/${id}?${qs.stringify({
        populate: `["ExchangerTransfer.client", "ExchangerTransfer.exchanger", "ExchangerTransfer.account", "Exchanger.owner"]`,
      })}`,
    }
  },
  target: getExchangerTransfer,
})

export const updateExchangerTransferStatus = fx<
  { status: string; reason?: string },
  ExchangerTransfer
>({
  method: 'PUT',
  url: `/exchanger_transfer/`,
})

sample({
  clock: [
    getExchangerTransfer.doneData,
    updateExchangerTransferStatus.doneData,
  ],
  fn: (doneData) => doneData.body,
  target: setExchangerTransfer,
})

sample({
  clock: submitStatus,
  fn: ({ requestId, status, reason }) => {
    return {
      body: {
        status,
        reason,
      },
      url: `/exchanger_transfer/${requestId}?${qs.stringify({
        populate: `["ExchangerTransfer.client", "ExchangerTransfer.exchanger", "ExchangerTransfer.account", "Exchanger.owner"]`,
      })}`,
    }
  },
  target: updateExchangerTransferStatus,
})
